<template>
  <div
    class="z-30 flex flex-row items-center justify-between w-full h-0 px-4 lg:px-8 lg:h-26 lg:min-h-26 max-h-26 bg-iq-grey-dark lg:border-b lg:border-iq-beige"
  >
    <slot />
  </div>
</template>
